<template>
  <v-form ref="form">
    <v-card>
      <v-subheader>Account Required Info</v-subheader>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="8">
            <v-text-field
              v-model="account.name"
              label="Company Full Name"
              :rules="requiredRules"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <v-text-field v-model="account.abbr" label="Company Code" />
          </v-col>
        </v-row>
        <v-select
          v-model="account.type"
          label="Account Type"
          :items="accountTypes"
        />
        <v-autocomplete
          v-model="account.timezone"
          label="Default Time Zone"
          :items="availableTimeZones"
        />
        <v-text-field
          type="number"
          v-model="account.userLimit"
          label="User Limit"
        />
        <v-text-field
          type="number"
          v-model="account.studentLimit"
          label="Student Limit"
        />
        <v-file-input
          v-if="!hideLogo"
          :show-size="true"
          hint="Please limited logo size to be under 1MB in size"
          v-model="account.logo"
          label="Company Logo"
        />
      </v-card-text>
    </v-card>

    <v-expansion-panels class="mt-5 mt-lg-10" v-model="expandedIndex">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Google Suite Configurations
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field
            v-model="account.googleCompanyDomain"
            label="Google Suite Domain"
          />
          <v-text-field
            v-model="account.googleAdminAccount"
            label="Google Suite Admin Account"
            hint="Email address"
          />
          <v-text-field
            v-model="account.googleDefaultCalendarAccount"
            label="Default Google Calendar Account"
            hint="Email address"
          />
          <v-textarea
            rows="1"
            :auto-grow="true"
            v-model="account.googleApiKey"
            label="Google Suite API Key"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          Account CDR Server Info
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field v-model="account.cdrHost" label="Host" />
          <v-text-field v-model="account.cdrServerUrl" label="Server URL" />
          <v-text-field
            autocomplete="off"
            aria-autocomplete="list"
            v-model="account.cdrServerUser"
            label="Server User Name"
          />
          <v-text-field
            autocomplete="off"
            aria-autocomplete="list"
            type="password"
            v-model="account.cdrServerPwd"
            label="Server Password"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> SMTP Server </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-text-field v-model="account.smtpHost" label="Host" />
          <v-text-field v-model="account.smtpPort" label="Port" />
          <v-text-field v-model="account.smtpFrom" label="Default From Email" />
          <v-text-field
            autocomplete="off"
            aria-autocomplete="list"
            v-if="account.smtpAuth"
            v-model="account.smtpUserName"
            label="User Name"
          />
          <v-text-field
            autocomplete="off"
            aria-autocomplete="list"
            type="password"
            v-if="account.smtpAuth"
            v-model="account.smtpPassword"
            label="Password"
          />
          <v-checkbox
            v-model="account.smtpAuth"
            label="Require Authentication"
          />
          <v-checkbox v-model="account.smtpStarttlsEnable" label="Enable TLS" />
          <v-checkbox v-model="account.smtpDebug" label="Debug Email" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
    formRef: {
      type: String,
      required: false,
    },
    hideLogo: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => {
    return {
      expandedIndex: null,
      accountTypes: ["Demo", "Trial", "Standard"],
      availableTimeZones: moment.tz.names(),
      requiredRules: [(v) => !!v || "This field is required"],
    };
  },
  computed: {
    ...mapGetters("navigation", ["navState", "isAppLoading"]),
  },
  mounted() {
    if (!this.account.timezone) {
      this.account.timezone = "America/New_York"; //Default
    }
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
  },
};
</script>

<style>
</style>